/* 🤖 this file was generated by svg-to-ts */
export const IconBigLightMuelleimer: {
    name: 'big-light-muelleimer';
    data: string;
} = {
    name: 'big-light-muelleimer',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M103 29.5H23a6.5 6.5 0 0 0 0 13h6.74l7.41 74.15a6.49 6.49 0 0 0 6.47 5.85h40.76a6.49 6.49 0 0 0 6.47-5.85l7.41-74.15H103a6.5 6.5 0 0 0 0-13m-17.13 86.65a1.49 1.49 0 0 1-1.49 1.35H43.62a1.49 1.49 0 0 1-1.49-1.35L34.76 42.5h58.48zM103 37.5H23a1.5 1.5 0 0 1 0-3h80a1.5 1.5 0 0 1 0 3m-59-13a2.5 2.5 0 0 0 2.5-2.5c0-6.88 4.35-11.5 10.83-11.5h13.34c6.48 0 10.83 4.62 10.83 11.5a2.5 2.5 0 0 0 5 0c0-9.71-6.5-16.5-15.83-16.5H57.33C48 5.5 41.5 12.29 41.5 22a2.5 2.5 0 0 0 2.5 2.5"/></svg>`,
};
